import {
  ApplicationRef,
  Component, ComponentFactory,
  ComponentFactoryResolver, ComponentRef,
  ElementRef,
  Inject,
  Injector, OnDestroy,
  OnInit, TemplateRef, Type,
  ViewChild
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

import { AppService } from '../../app.service';
import { LojaModelService } from '../../service/loja.model.service';
import { ConsLojaAPP, ConsLojasComVendedorAPP } from 'app/vo/sitevo.vo';
import { VendedoresComponent } from '../vendedores/vendedores.component';

@Component({
  selector: 'lojas-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['../../app.css', '../lojas.css']
})
export class ListaComponent implements OnInit, OnDestroy {

  private _componentRef: ComponentRef<VendedoresComponent> = null;
  lojaUrlVoltar: string = '';
  isLoading: boolean = false;
  isDetalhesLoja: boolean = false;

  @ViewChild('divLoadVendedoresComponent') divLoadVendedoresComponent: ElementRef;

  constructor(
    private app: AppService,
    private loja: LojaModelService,
    private router: Router,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    @Inject(DOCUMENT) private document: Document
  ) { }

  get lojas(): ConsLojasComVendedorAPP { return this.app.lojas; }

  ngOnInit(): void {
    if (this.app.lojas == null) {
      this.isLoading = true;
      this.loja.getLojasComVendedor()
        .then((data: ConsLojasComVendedorAPP) => {
          this.app.lojas = data;
        })
        .catch(erro => console.error(erro))
        .then(() => this.isLoading = false);
    }
    this.lojaUrlVoltar = this.app.lojaUrlVoltar;
    this.app.lojaUrlVoltar = '';
  }

  ngOnDestroy() {
    this.unloadComponent();
  }

  getQtdVendedores(codEmpresa: number): number {
    const vendedores = this.lojas.listVendedor.filter(i => i.listEmpresa.find(e => e === codEmpresa));
    return vendedores.length;
  }

  abrirDetalhesLoja(loja: ConsLojaAPP) {
    this.app.lojaUrlVoltar = this.lojaUrlVoltar;
    this.app.lojaSelecionada = loja.codEmpresa;
    // this.router.navigate(['/lojas/vendedores']);
    this.isDetalhesLoja = true;
    const div = this.divLoadVendedoresComponent.nativeElement;
    this._componentRef = this.app.loadComponent<VendedoresComponent>(VendedoresComponent, div);
  }

  fecharDetalhesLoja() {
    this.isDetalhesLoja = false;
    this.unloadComponent();
  }

  private unloadComponent() {
    if (this._componentRef != null) {
      const componentEl = this._componentRef.location.nativeElement;
      componentEl.parentNode.removeChild(componentEl);
      this._componentRef.destroy();
    }
    this._componentRef = null;
  }

  mapa(loja: ConsLojaAPP) {
    const endereco = loja.logradouro.replace(',', '') + ' , ' + loja.numero + ' , ' + loja.bairro + ' , ' + loja.cidade;
    const queryMaps = endereco.split(' ').filter(i => i.length > 0).join('+');
    const win = window.open('https://www.google.com/maps/search/?api=1&query=' + encodeURI(queryMaps), '_blank');
    win.focus();
  }

  voltar() {
    this.router.navigate([this.lojaUrlVoltar]);
  }

}
